module.exports = __webpack_public_path__ + "static/media/rsz_1alienworlds.ef83b762.webp";